import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {MaterialModule} from "../../material/material.module";
import { PropertylistComponent } from './properties/propertylist.component';
 


@NgModule({
  declarations: [
    PropertylistComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
  ]
})
export class PropertyListModule { }
